import { api } from '../api';

export const messageService = {
  async fetchMessages(params) {
    return api.get('messages', { params });
  },

  async fetchMessage(id) {
    return api.get('messages/' + id );
  },

  async replyMessage(id, params) {
    return api.post('messages/' + id, { '_method': 'PUT', ...params });
  },

  async toggleFavorite(id) {
    return api.post('messages/' + id + '/favorite');
  },
};